// The UI languages Lorvok ships. English is the source/fallback; the rest are
// among the most widely spoken languages online. All are left-to-right, so no
// RTL handling is needed yet (Arabic/Hebrew would need `dir` support).
export interface UiLanguage {
  code: string;
  /** Endonym — the language's own name, shown in the picker. */
  label: string;
}

export const UI_LANGUAGES: readonly UiLanguage[] = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
  { code: "pt", label: "Português" },
  { code: "fr", label: "Français" },
  { code: "de", label: "Deutsch" },
  { code: "ru", label: "Русский" },
  { code: "zh", label: "中文" },
  { code: "ja", label: "日本語" }
] as const;

export const DEFAULT_LANGUAGE = "en";

export const SUPPORTED_LANGUAGE_CODES: readonly string[] = UI_LANGUAGES.map((l) => l.code);

/**
 * Normalises a raw language tag (e.g. "en-US", "PT_BR", "zh-Hans") to a
 * supported code, or null when unsupported. Only the primary subtag is used.
 */
export function resolveLanguage(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const primary = raw.trim().toLowerCase().split(/[-_]/)[0];
  return SUPPORTED_LANGUAGE_CODES.includes(primary) ? primary : null;
}
